import * as Constant from '../../actions/constants'

export default (state = [], action) => {
  switch (action.type) {
    case Constant.LOCATIONS_GET_SUCCESS:
      return action.payload
    default:
      return state
  }
}
